import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { lastValueFrom, map } from 'rxjs';
import {
  FinancialControllerService,
  PaymentResponseMessageType
} from 'src/app/admin-api';
import { AppDialogService } from 'src/app/services/dialog.service';
import { ErrorModalStorageService } from 'src/app/services/error-modal-storage.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-payment-response-message-type-form',
  templateUrl: './payment-response-message-type-form.component.html',
  styleUrl: './payment-response-message-type-form.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class PaymentResponseMessageTypeFormComponent implements OnInit {
  private financialControllerService = inject(FinancialControllerService);
  private messageService = inject(MessageService);
  private errorModalStorageService = inject(ErrorModalStorageService);

  @Input()
  paymentResponseMessageType: PaymentResponseMessageType = undefined;

  @Output()
  updated = new EventEmitter<PaymentResponseMessageType>();

  @Input()
  permission = false;

  form = this.newForm;
  iconOptions: string[];

  async ngOnInit() {
    this.form = this.newForm;
    LoaderService.showLoader();
    await this.findIcons();
    LoaderService.showLoader(false);
  }

  async savePaymentResponseMessageType(): Promise<void> {
    if (this.form?.valid) {
      LoaderService.showLoader();
      try {
        const request: PaymentResponseMessageType = { ...this.form.value };
        this.paymentResponseMessageType = await lastValueFrom(
          this.financialControllerService
            .updateResponseMessageType(request)
            .pipe(map((data) => data.result))
        );
        this.messageService.add({
          severity: 'success',
          detail: 'Tipo de erro atualizado com sucesso',
          summary: 'Sucesso'
        });
        this.updated.emit(this.paymentResponseMessageType);
      } catch (error: any) {
        AppDialogService.showErrorDialog(error);
      }
      LoaderService.showLoader(false);
    }
  }

  async findIcons() {
    try {
      this.iconOptions =
        await this.errorModalStorageService.listFilesAndGetPublicLinks();
    } catch (error) {
      this.iconOptions = [];
      AppDialogService.showErrorDialog(error);
    }
  }

  imageName(url: string): string {
    const parts = url.split('/');
    return parts[parts.length - 1].split('?')[0]; // Get the last part of the URL and remove query parameters
  }

  get newForm() {
    return new FormGroup({
      paymentResponseMessageTypeId: new FormControl({
        value: this.paymentResponseMessageType?.paymentResponseMessageTypeId,
        disabled: !this.permission
      }),
      typeContent: new FormControl(
        {
          value: this.paymentResponseMessageType?.typeContent,
          disabled: !this.permission
        },
        [Validators.minLength(4), Validators.maxLength(30), Validators.required]
      ),
      messageContent: new FormControl(
        {
          value: this.paymentResponseMessageType?.messageContent,
          disabled: !this.permission
        },
        [
          Validators.minLength(30),
          Validators.maxLength(100),
          Validators.required
        ]
      ),
      iconURL: new FormControl(
        {
          value: this.paymentResponseMessageType?.iconURL,
          disabled: !this.permission
        },
        Validators.required
      ),
      buttonText: new FormControl(
        {
          value: this.paymentResponseMessageType?.buttonText,
          disabled: !this.permission
        },
        Validators.required
      )
    });
  }
}
